//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'PzOfertaUpDescuentosUy',
  inject: ['myForm'],
  mounted: function mounted() {}
};